import React, { useRef } from "react"
import { ProductsDescription } from "."
import { WrapperSEO } from "./ProductsDescription.style"

interface Props {
  id?: string
  data: string
  className?: string
}

export function ProductsDescriptionSEOView({ id = "", data, className }: Props) {
  return (
    <WrapperSEO className={className}>
      <ProductsDescription data={data} />
    </WrapperSEO>
  )
}

